export default "__VITE_ASSET__t5QhnOxT__"